<app-header-user></app-header-user>
<!-- Container principal -->
<div class="container pt-4 pb-5">
    <div class="row mb-3">
        <!-- CARD 1: PROFIL PACIENT -->
        <div class="col-12 col-md-6 col-lg-4">
            <div class="card dashboard-card h-100 profile-card">
                <!-- Header -->
                <div
                    class="card-header d-flex align-items-center justify-content-between profile-header"
                >
                    <div class="d-flex align-items-center">
                        <div class="avatar-circle me-2">
                            <span>{{ (user?.name || "P")[0] }}</span>
                        </div>
                        <div>
                            <h5 class="mb-0">Profil pacient</h5>
                            <small class="text-muted">
                                {{ user?.name || "username nedefinit" }}
                            </small>
                        </div>
                    </div>
                    <!--
      <span
        class="badge status-pill"
        [ngClass]="
          user?.status === 'Asigurat'
            ? 'bg-success'
            : 'bg-warning'
        "
      >
        {{ user?.status || 'Nespecificat' }}
      </span>
      -->
                </div>

                <!-- Corp card -->
                <div class="card-body">
                    <ul class="profile-list">
                        <li>
                            <span class="icon bx bx-user"></span>
                            <div class="content">
                                <div class="label">Nume și prenume</div>
                                <div class="value">
                                    {{ user?.name || "N/A" }}
                                </div>
                            </div>
                        </li>

                        <li>
                            <span class="icon bx bx-hash"></span>
                            <div class="content">
                                <div class="label">CNP</div>
                                <div class="value">
                                    {{ user?.cnp || "N/A" }}
                                </div>
                            </div>
                        </li>

                        <li>
                            <span class="icon bx bx-map"></span>
                            <div class="content">
                                <div class="label">Adresă</div>
                                <div class="value">
                                    {{ user?.address || "N/A" }}
                                </div>
                            </div>
                        </li>

                        <li>
                            <span class="icon bx bx-id-card"></span>
                            <div class="content">
                                <div class="label">Act identitate</div>
                                <div class="value">
                                    {{
                                        (user?.idCardSeries || "-") +
                                            " " +
                                            (user?.idCardNumber || "-")
                                    }}
                                </div>
                            </div>
                        </li>

                        <!-- Telefon -->
                        <li>
                            <span class="icon bx bx-phone"></span>
                            <div class="content">
                                <div class="label">Telefon</div>
                                <div class="value">
                                    {{ user?.phone || "Nespecificat" }}
                                </div>
                            </div>
                        </li>

                        <!-- Email -->
                        <li>
                            <span class="icon bx bx-envelope"></span>
                            <div class="content">
                                <div class="label">Email</div>
                                <div class="value">
                                    {{ user?.email || "Nespecificat" }}
                                </div>
                            </div>
                        </li>

                        <!-- Acord GDPR -->
                        <li>
                            <span class="icon bx bx-lock-alt"></span>
                            <div class="content">
                                <div class="label">Acord GDPR</div>
                                <div
                                    class="value d-flex align-items-center gap-2"
                                >
                                    <span
                                        class="badge px-3 py-1"
                                        [ngClass]="
                                            user?.isGdpr
                                                ? 'bg-success'
                                                : 'bg-danger'
                                        "
                                    >
                                        {{
                                            user?.isGdpr ? "Semnat" : "Nesemnat"
                                        }}
                                    </span>
                                    <button
                                        *ngIf="!user?.isGdpr"
                                        type="button"
                                        class="btn btn-sm btn-outline-primary btn-rounded"
                                        (click)="goToGdpr()"
                                    >
                                        Semnează
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <!-- Editare date de contact -->
                    <div class="mt-3">
                        <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary btn-rounded"
                            (click)="editingContact = !editingContact"
                        >
                            {{
                                editingContact
                                    ? "Renunță"
                                    : "Editează date contact"
                            }}
                        </button>
                    </div>

                    <div *ngIf="editingContact" class="mt-3">
                        <div class="mb-2">
                            <label class="form-label mb-1">Telefon</label>
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                [(ngModel)]="editContact.phone"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="Număr de telefon"
                            />
                        </div>
                        <div class="mb-2">
                            <label class="form-label mb-1">Email</label>
                            <input
                                type="email"
                                class="form-control form-control-sm"
                                [(ngModel)]="editContact.email"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="Adresa de email"
                            />
                        </div>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm btn-rounded"
                            (click)="saveContact()"
                        >
                            Salvează
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD 2: PROGRAMĂRI ACTIVE -->
        <div class="col-12 col-lg-8">
            <div class="card dashboard-card h-100">
                <div
                    class="card-header d-flex align-items-center justify-content-between"
                >
                    <h5 class="mb-0">
                        <i class="bx bx-calendar me-2"></i>Programări active
                    </h5>
                    <div class="d-none d-md-block">
                        <a
                            routerLink="/programari"
                            class="btn btn-sm btn-outline-light me-1"
                        >
                            Vezi toate programările
                        </a>
                        <a
                            routerLink="/efectueaza-programare"
                            class="btn btn-sm btn-light"
                        >
                            Creează programare
                        </a>
                    </div>
                </div>

                <div class="card-body p-0">
                    <!-- Loading -->
                    <div *ngIf="loadingAppointments" class="text-center py-4">
                        <div
                            class="spinner-border spinner-sm text-success"
                        ></div>
                    </div>

                    <!-- LISTĂ PROGRAMĂRI ACTIVE (max 5) -->
                    <div
                        *ngIf="!loadingAppointments && appointments?.length > 0"
                        class="appointments-list"
                    >
                        <div
                            *ngFor="
                                let appt of appointments.slice(0, 5);
                                trackBy: trackByFn
                            "
                            class="appt-item p-3 border-bottom"
                        >
                            <!-- Linia 1: icon + data + status -->
                            <div
                                class="d-flex justify-content-between align-items-start mb-2"
                            >
                                <div class="d-flex align-items-start">
                                    <div class="calendar-icon me-2">
                                        <i class="bx bx-calendar"></i>
                                    </div>
                                    <div>
                                        <div class="fw-semibold">
                                            Dr. {{ appt.doctorName }} –
                                            {{ appt.specialtyName }}
                                        </div>
                                        <div class="small text-muted">
                                            {{
                                                appt.startDate | date: "d MMM"
                                            }},
                                            {{
                                                appt.startHour ||
                                                    (appt.startDate
                                                        | date: "HH:mm")
                                            }}
                                            –
                                            <span
                                                class="badge ms-1"
                                                [ngClass]="
                                                    getStatus(appt) === 'Activa'
                                                        ? 'bg-success'
                                                        : 'bg-warning'
                                                "
                                            >
                                                {{
                                                    getStatus(appt) === "Activa"
                                                        ? "Confirmat"
                                                        : getStatus(appt)
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Linia 2: acțiuni -->
                            <div
                                class="d-flex flex-wrap gap-2 justify-content-end appt-actions"
                            >
                                <button
                                    type="button"
                                    class="btn btn-xs btn-outline-primary btn-rounded"
                                    (click)="viewDetails(appt)"
                                >
                                    Detalii
                                </button>
                                <!-- <button
                                    type="button"
                                    class="btn btn-xs btn-outline-warning btn-rounded"
                                    (click)="reschedule(appt)"
                                >
                                    Reprogramează
                                </button> -->
                                <button
                                    type="button"
                                    class="btn btn-xs btn-outline-danger btn-rounded"
                                    (click)="cancel(appt)"
                                >
                                    Anulează
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- NO DATA -->
                    <div
                        *ngIf="
                            !loadingAppointments &&
                            (!appointments || appointments.length === 0)
                        "
                        class="no-data p-4 text-center"
                    >
                        <i
                            class="bx bx-calendar-x bx-lg text-muted mb-3 d-block"
                        ></i>
                        <h6 class="text-muted mb-1">Nicio programare activă</h6>
                        <p class="text-muted small mb-3">
                            Programează-ți prima vizită online.
                        </p>
                        <a
                            routerLink="/efectueaza-programare"
                            class="btn btn-success"
                        >
                            Creează programare
                        </a>
                    </div>

                    <!-- Footer link: vezi istoricul -->
                    <div class="card-footer bg-light text-center small">
                        <a
                            routerLink="/programari"
                            class="text-decoration-none"
                        >
                            → Vezi istoricul programărilor
                        </a>
                    </div>
                </div>

                <!-- Butoane pentru mobile sub card -->
                <div class="card-footer d-md-none border-0 text-center pt-0">
                    <a
                        routerLink="/programari"
                        class="btn btn-outline-success btn-sm btn-rounded me-2 mb-2"
                    >
                        Vezi toate programările
                    </a>
                    <a
                        routerLink="/programare-noua"
                        class="btn btn-success btn-sm btn-rounded mb-2"
                    >
                        Creează programare
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- CARD 3: REZULTATE MEDICALE NOI (Mini Tabel) -->
    <div class="row mb-3">
        <div class="col-12">
            <div class="card dashboard-card h-100">
                <div
                    class="card-header d-flex align-items-center justify-content-between"
                >
                    <h5 class="mb-0">
                        <i class="bx bx-file-medical me-2"></i>Rezultate
                        Medicale Noi
                    </h5>
                    <a
                        routerLink="/rezultatele-mele"
                        class="btn btn-sm btn-outline-light"
                        >→ Istoricul analizelor</a
                    >
                </div>
                <div class="card-body p-0">
                    <div *ngIf="loadingResults" class="text-center py-4">
                        <div class="spinner-border spinner-sm text-info"></div>
                    </div>

                    <!-- MINI TABLE LAST 5 -->
                    <div
                        *ngIf="!loadingResults && results?.length > 0"
                        class="table-responsive"
                    >
                        <table class="table table-sm mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>Tip analiza</th>
                                    <th>Categorie</th>
                                    <th>Data</th>
                                    <th>Doctor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="
                                        let result of results.slice(0, 5);
                                        trackBy: trackByFn
                                    "
                                >
                                    <td>
                                        {{
                                            (result.analysisType || "").length >
                                            100
                                                ? (result.analysisType
                                                      | slice: 0 : 100) + "..."
                                                : result.analysisType
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            result.category?.toLowerCase() ===
                                            "radiology"
                                                ? "Radiologie"
                                                : result.category?.toLowerCase() ===
                                                    "laboratory"
                                                  ? "Laborator"
                                                  : result.category
                                        }}
                                    </td>
                                    <td>
                                        {{ result.date | date: "dd/MM/yy" }}
                                    </td>
                                    <td>{{ result.doctorName }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- NO DATA -->
                    <div
                        *ngIf="
                            !loadingResults &&
                            (!results || results.length === 0)
                        "
                        class="no-data p-4 text-center"
                    >
                        <i
                            class="bx bx-file-medical-x bx-lg text-muted mb-3"
                        ></i>
                        <h6 class="text-muted mb-1">Niciun rezultat nou</h6>
                        <p class="text-muted small">
                            Rezultatele apar după analize
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <!-- CARD 4: BILETE TRIMITERE (Complex Table) -->
        <div class="col-12 col-lg-6">
            <div class="card dashboard-card">
                <div
                    class="card-header d-flex align-items-center justify-content-between"
                >
                    <h5 class="mb-0">
                        <i class="bx bx-clipboard me-2"></i>Bilete de Trimitere Noi
                    </h5>
                    <div>
                        <button
                            class="btn btn-sm btn-outline-light me-1"
                            routerLink="/biletele-mele"
                        >
                            Administrează
                        </button>
                        <button
                            class="btn btn-sm btn-light"
                            routerLink="/adauga-bilet"
                        >
                            Încarcă bilet nou
                        </button>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div *ngIf="loadingTickets" class="text-center py-4">
                        <div
                            class="spinner-border spinner-sm text-warning"
                        ></div>
                    </div>

                    <!-- MINI TABLE LAST 5 (interne + externe) -->
                    <div
                        *ngIf="!loadingTickets && homeTickets?.length > 0"
                        class="table-responsive"
                    >
                        <table class="table table-sm mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>Data</th>
                                    <th>Serie/Nr</th>
                                    <th>Tip</th>
                                    <th>Specialitate</th>
                                    <th>Medic</th>
                                    <th>Valabil</th>
                                    <th>Nr programari rămase</th>
                                    <th>Origine</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="
                                        let ticket of homeTickets.slice(0, 5);
                                        trackBy: trackByFn
                                    "
                                >
                                    <td>
                                        {{
                                            ticket.date || ticket.createdDate
                                                | date: "dd/MM"
                                        }}
                                    </td>

                                    <td>
                                        {{ ticket.batch }}/{{ ticket.number }}
                                    </td>

                                    <td>{{ ticket.type?.labels[0]?.label }}</td>

                                    <td>
                                        {{
                                            ticket.specialtyName ||
                                                ticket.senderSpecialization
                                        }}
                                    </td>

                                    <td>
                                        {{
                                            ticket.doctorName ||
                                                ticket.senderDoctor
                                        }}
                                    </td>

                                    <td>{{ ticket.validity }} zile</td>

                                    <td>
                                        <span class="badge bg-info">
                                            {{ 3 - ticket.used }}/3
                                        </span>
                                    </td>

                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="
                                                ticket.isExternal
                                                    ? 'bg-warning'
                                                    : 'bg-primary'
                                            "
                                        >
                                            {{
                                                ticket.isExternal
                                                    ? "Extern"
                                                    : "Intern"
                                            }}
                                        </span>
                                    </td>

                                    <td>
                                        <span
                                            class="badge bg-{{
                                                ticket.status === 'Validat'
                                                    ? 'success'
                                                    : ticket.status ===
                                                        'În așteptare'
                                                      ? 'warning'
                                                      : 'danger'
                                            }}"
                                        >
                                            {{
                                                ticket.status === "Active"
                                                    ? "ACTIV"
                                                    : "EXPIRAT"
                                            }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- NO DATA -->
                    <div
                        *ngIf="
                            !loadingTickets &&
                            (!homeTickets || homeTickets.length === 0)
                        "
                        class="no-data p-4 text-center"
                    >
                        <i class="bx bx-clipboard-x bx-lg text-muted mb-3"></i>
                        <h6 class="text-muted mb-1">Niciun bilet activ</h6>
                        <p class="text-muted small mb-3">
                            Încarcă primul bilet (intern sau extern)
                        </p>
                        <button class="btn btn-warning">
                            Încarcă bilet nou
                        </button>
                    </div>
                </div>
            </div>
          
        </div>

        <!-- CARD 5: DOCUMENTE MEDICALE -->
        <div class="col-12 col-lg-6">
            <div class="card dashboard-card">
                <div class="card-header">
                    <h5 class="mb-0">
                        <i class="bx bx-folder-open me-2"></i>Documente Medicale Noi
                    </h5>
                </div>
                <div class="card-body">
                    <div *ngIf="loadingDocuments" class="text-center py-4">
                        <div class="spinner-border spinner-sm"></div>
                    </div>

                    <!-- LIST LAST 5 -->
                    <div *ngIf="!loadingDocuments && documents?.length > 0">
                        <div
                            *ngFor="
                                let doc of documents.slice(0, 5);
                                trackBy: trackByFn
                            "
                            class="doc-item p-2 border rounded mb-2 d-flex justify-content-between align-items-center"
                        >
                            <div>
                                <strong>{{ doc.documentType?.labels[0]?.label || doc.name }}</strong
                                ><br />
                                <small class="text-muted"
                                    >{{ doc.date | date: "dd/MM/yy" }} |
                                    {{ doc.documentType?.label }}</small
                                >
                            </div>
                            <a
                                (click)="download(doc)"
                                class="btn btn-sm btn-success"
                            >
                                <i class="bx bx-download"></i>
                            </a>
                        </div>
                        <button
                            class="btn btn-outline-secondary w-100"
                            routerLink="/documentele-mele"
                        >
                            Vezi toate documentele
                        </button>
                    </div>

                    <!-- NO DATA -->
                    <div
                        *ngIf="
                            !loadingDocuments &&
                            (!documents || documents.length === 0)
                        "
                        class="no-data text-center"
                    >
                        <i class="bx bx-folder bx-lg text-muted mb-3"></i>
                        <h6 class="text-muted">Niciun document</h6>
                        <p class="text-muted small">
                            Documente după vizite medicale
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD 6: NOTIFICĂRI -->
        <!-- CARD 6: NOTIFICĂRI -->
        <div class="col-12">
            <div class="card dashboard-card">
                <div class="card-header bg-gradient-danger">
                    <h5 class="mb-0">
                        <i class="bx bx-bell me-2"></i>Notificări
                    </h5>

                    <button
                        type="button"
                        class="btn btn-sm btn-outline-light"
                        *ngIf="unreadCount > 0"
                        (click)="markAllAsRead()"
                    >
                        Marchează toate ca citite
                    </button>
                </div>

                <div class="card-body">
                    <!-- Loading -->
                    <div
                        *ngIf="loadingNotifications"
                        class="text-center text-muted py-3"
                    >
                        Se încarcă notificările...
                    </div>

                    <!-- Lista notificări -->
                    <div
                        *ngIf="
                            !loadingNotifications && notifications?.length > 0
                        "
                    >
                        <div
                            *ngFor="
                                let notif of notifications.slice(0, 5);
                                trackBy: trackByFn
                            "
                            class="notif-item p-2 border-bottom small d-flex justify-content-between align-items-start"
                            [class.unread]="!notif.read"
                            (click)="openNotification(notif)"
                        >
                            <div class="me-2">
                                <div class="d-flex align-items-center gap-1">
                                    <span
                                        *ngIf="!notif.read"
                                        class="unread-dot"
                                    ></span>
                                    <strong>{{ notif.title }}</strong>
                                </div>
                                <div class="text-muted notif-message">
                                    {{
                                        (notif.message || "").length > 80
                                            ? (notif.message | slice: 0 : 80) +
                                              "..."
                                            : notif.message
                                    }}
                                </div>
                            </div>
                            <div class="text-end">
                                <span class="text-muted d-block">
                                    {{ notif.createdAt | date: "dd/MM HH:mm" }}
                                </span>
                                <span
                                    class="badge mt-1"
                                    [ngClass]="
                                        notif.read
                                            ? 'bg-secondary'
                                            : 'bg-danger'
                                    "
                                >
                                    {{ notif.read ? "Citită" : "Nouă" }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- No data -->
                    <div
                        *ngIf="
                            !loadingNotifications &&
                            (!notifications || notifications.length === 0)
                        "
                        class="no-data text-center py-3"
                    >
                        <i class="bx bx-bell bx-lg text-muted mb-2"></i>
                        <h6 class="text-muted mb-0">Nicio notificare</h6>
                        <small class="text-muted"
                            >Vei vedea aici ultimele mesaje importante despre
                            rezultate, programări și documente.</small
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    *ngIf="showGdprModal"
    style="display: block; background: rgba(0, 0, 0, 0.5)"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Acord privind prelucrarea datelor cu caracter personal
                    (GDPR)
                </h5>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="closeGdprModal()"
                ></button>
            </div>

            <div class="modal-body">
                <p>
                    Prin bifarea opțiunii „Sunt de acord”, îmi exprim
                    consimțământul ca Spitalul CF Pașcani să prelucreze datele
                    mele cu caracter personal, inclusiv date medicale, în
                    scopul:
                </p>
                <ul>
                    <li>
                        creării și administrării contului meu în Portalul Web al
                        Pacientului;
                    </li>
                    <li>
                        accesării documentelor și informațiilor medicale
                        personale;
                    </li>
                    <li>
                        comunicării informațiilor legate de serviciile medicale
                        furnizate.
                    </li>
                </ul>
                <p>
                    Datele sunt prelucrate în condiții de confidențialitate și
                    securitate, conform Regulamentului (UE) 2016/679 (GDPR).
                </p>
                <p>
                    Am luat la cunoștință că îmi pot retrage consimțământul
                    oricând, printr-o solicitare adresată spitalului.
                </p>

                <div class="mt-3">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="gdprConsent"
                            id="gdprAgree"
                            [(ngModel)]="gdprChoice"
                            [value]="'agree'"
                        />
                        <label class="form-check-label" for="gdprAgree">
                            Sunt de acord
                        </label>
                    </div>
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="gdprConsent"
                            id="gdprDisagree"
                            [(ngModel)]="gdprChoice"
                            [value]="'disagree'"
                        />
                        <label class="form-check-label" for="gdprDisagree">
                            Nu sunt de acord
                        </label>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="closeGdprModal()"
                >
                    Anulează
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="!gdprChoice"
                    (click)="confirmGdpr()"
                >
                    Confirmă
                </button>
            </div>
        </div>
    </div>
</div>
<!-- MODAL DETALII PROGRAMARE -->
<div
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    *ngIf="selectedAppointment"
    [ngClass]="{ 'd-block': selectedAppointment }"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="bx bx-calendar me-2"></i>
                    Detalii programare
                </h5>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="closeDetails()"
                ></button>
            </div>

            <div class="modal-body">
                <!-- Doctor + specialitate -->
                <div class="mb-3">
                    <div class="fw-semibold">
                        Dr. {{ selectedAppointment.doctorName }}
                    </div>
                    <div class="text-muted small">
                        {{ selectedAppointment.specialtyName }}
                    </div>
                </div>

                <!-- Data + oră -->
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="text-muted small">Data</div>
                        <div class="fw-semibold">
                            {{
                                selectedAppointment.startDate
                                    | date: "EEEE, d MMMM yyyy"
                            }}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="text-muted small">Ora</div>
                        <div class="fw-semibold">
                            {{
                                selectedAppointment.startHour ||
                                    (selectedAppointment.startDate
                                        | date: "HH:mm")
                            }}
                        </div>
                    </div>
                </div>

                <!-- Info suplimentare (tip, comentarii, etc.) -->
                <div class="row mb-3">
                    <div
                        class="col-md-6"
                        *ngIf="selectedAppointment.scheduleComment"
                    >
                        <div class="text-muted small">Tip programare</div>
                        <div class="fw-semibold">
                            {{ selectedAppointment.scheduleComment }}
                        </div>
                    </div>
                    <div class="col-md-6" *ngIf="selectedAppointment.message">
                        <div class="text-muted small">Mesaj</div>
                        <div class="fw-semibold">
                            {{ selectedAppointment.message }}
                        </div>
                    </div>
                </div>

                <div
                    *ngIf="
                        selectedAppointment.portalComment ||
                        selectedAppointment.comment
                    "
                >
                    <div class="text-muted small">Observații</div>
                    <div class="border rounded p-2 small">
                        {{
                            selectedAppointment.portalComment ||
                                selectedAppointment.comment
                        }}
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    (click)="closeDetails()"
                >
                    Închide
                </button>
                <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    (click)="cancel(selectedAppointment)"
                >
                    Anulează programarea
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Backdrop -->
<div
    class="modal-backdrop fade show"
    *ngIf="selectedAppointment"
    (click)="closeDetails()"
></div>
